import api from '../../api/index';
import config from '../../../static/config.json';

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
	// 产品展会 
	addExhibitionFollower({ rootState, commit }, opt) { // 展会产品
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibition/follow`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	delExhibitionFollower({ rootState }, opt) { // 取消展会关注
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v1/exhibition/follow`, { data: opt, ...rootState.header }).then(({
				data
			}) => {
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
	addExhibitionView({ rootState, commit }, opt) { // 展会添加浏览记录
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/addview`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	// 产品展会 end

	// 产品关注
	getProductFollower({ rootState, commit }, opt) { // 获取产品关注
		return new Promise((resolve, reject) => {
			api.get(`${config.https.api}/api/v1/productfollower/query`, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	// 产品关注分页
	getProductLove({ rootState, commit }, opt) { // 获取产品关注
		return new Promise((resolve, reject) => {
			api.get(`${config.https.api}/api/v1/member/getmypageproductinfopagedlist?exhibitionId=${opt.exhibitionId}&userId=${opt.userId}&pageIndex=${opt.pageIndex}&pageSize=${opt.pageSize}`, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	addProductFollower({ rootState, commit }, opt) { // 关注产品
		return new Promise((resolve, reject) => {
			api.get(`${config.https.api}/api/v1/productfollower`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	// 产品关注 end

	// 展商关注
	getExhibitorFollower({ rootState, commit }, opt) { // 展商关注
		return new Promise((resolve, reject) => {
			api.get(`${config.https.api}/api/v1/member/getmypageexhibitorpagedlist?exhibitionId=${opt.exhibitionId}&userId=${opt.userId}&pageIndex=${opt.pageIndex}&pageSize=${opt.pageSize}`, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	addExhibitorFollower({ rootState, commit }, opt) { // 关注展商
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorfollower`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	hasExhibitorFollower({ rootState, commit }, opt) { // 获取是否关注展商
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorfollower`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	// 展商关注 end
	//关注话题
	followerTopic({
		rootState
		}, opt) {
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/themefollow`, opt, rootState.header).then(({
				data
				}) => {
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
	//取消关注话题
	delFollowerTopic({rootState},body){
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/themefollow/remove?themeId=${body.themeId}&memberId=${body.memberId}`,  rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	// 商机的关注
	followerSupply({
		rootState
		}, opt) {
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/supplydemandfollower`, opt, rootState.header).then(({
				data
				}) => {
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
	delFollowerSupply({
		rootState
		}, opt) {
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/supplydemandfollower/remove?supplyDemandId=${opt.DemandId}&memberId=${opt.memberId}`, rootState.header).then(({
				data
				}) => {
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
	// 添加新闻浏览量
	addNewsView({rootState},opt){
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/articleview`,opt,rootState.header).then(({
				data
				}) => {
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
	// 打招呼
	SayHello({rootState},opt){
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorsayhello`,opt,rootState.header).then(({
				data
				}) => {
					console.log(data,'打招呼')
				if (data) {
					resolve(data);
				}
			});
		}).catch(err => {
			console.log(err);
		});
	},
}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
} 
